// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file webgame/v1/world_map.proto (package webgame.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { BuildingInfo } from "../../building/v1/building_pb";
import { file_building_v1_building } from "../../building/v1/building_pb";
import type { Bounds } from "./geo_pb";
import { file_webgame_v1_geo } from "./geo_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file webgame/v1/world_map.proto.
 */
export const file_webgame_v1_world_map: GenFile = /*@__PURE__*/
  fileDesc("Chp3ZWJnYW1lL3YxL3dvcmxkX21hcC5wcm90bxIKd2ViZ2FtZS52MSJRChxMaXN0QnVpbGRpbmdzSW5Cb3VuZHNSZXF1ZXN0EiIKBmJvdW5kcxgBIAEoCzISLndlYmdhbWUudjEuQm91bmRzEg0KBWxpbWl0GAIgASgFIo4BCh1MaXN0QnVpbGRpbmdzSW5Cb3VuZHNSZXNwb25zZRIsCglidWlsZGluZ3MYASADKAsyGS5idWlsZGluZy52MS5CdWlsZGluZ0luZm8SLAoQZWZmZWN0aXZlX2JvdW5kcxgCIAEoCzISLndlYmdhbWUudjEuQm91bmRzEhEKCXRydW5jYXRlZBgDIAEoCDJ/Cg9Xb3JsZE1hcFNlcnZpY2USbAoVTGlzdEJ1aWxkaW5nc0luQm91bmRzEigud2ViZ2FtZS52MS5MaXN0QnVpbGRpbmdzSW5Cb3VuZHNSZXF1ZXN0Gikud2ViZ2FtZS52MS5MaXN0QnVpbGRpbmdzSW5Cb3VuZHNSZXNwb25zZUI3WjVnaXRodWIuY29tL21hZmlhZ28vc2VydmVyL2dlbi9nby93ZWJnYW1lL3YxO3dlYmdhbWV2MWIGcHJvdG8z", [file_building_v1_building, file_webgame_v1_geo]);

/**
 * @generated from message webgame.v1.ListBuildingsInBoundsRequest
 */
export type ListBuildingsInBoundsRequest = Message<"webgame.v1.ListBuildingsInBoundsRequest"> & {
  /**
   * @generated from field: webgame.v1.Bounds bounds = 1;
   */
  bounds?: Bounds | undefined;

  /**
   * Default 500, max 1000. Results are ordered by distance from the centre
   * of the effective bounds, so truncation is stable while panning.
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message webgame.v1.ListBuildingsInBoundsRequest.
 * Use `create(ListBuildingsInBoundsRequestSchema)` to create a new message.
 */
export const ListBuildingsInBoundsRequestSchema: GenMessage<ListBuildingsInBoundsRequest> = /*@__PURE__*/
  messageDesc(file_webgame_v1_world_map, 0);

/**
 * @generated from message webgame.v1.ListBuildingsInBoundsResponse
 */
export type ListBuildingsInBoundsResponse = Message<"webgame.v1.ListBuildingsInBoundsResponse"> & {
  /**
   * @generated from field: repeated building.v1.BuildingInfo buildings = 1;
   */
  buildings: BuildingInfo[];

  /**
   * The bounds actually served after clamping (max ~6.5 km per side).
   *
   * @generated from field: webgame.v1.Bounds effective_bounds = 2;
   */
  effectiveBounds?: Bounds | undefined;

  /**
   * More buildings matched than `limit`, or the bounds were clamped.
   *
   * @generated from field: bool truncated = 3;
   */
  truncated: boolean;
};

/**
 * Describes the message webgame.v1.ListBuildingsInBoundsResponse.
 * Use `create(ListBuildingsInBoundsResponseSchema)` to create a new message.
 */
export const ListBuildingsInBoundsResponseSchema: GenMessage<ListBuildingsInBoundsResponse> = /*@__PURE__*/
  messageDesc(file_webgame_v1_world_map, 1);

/**
 * WorldMapService is the web map's SIDE-EFFECT-FREE building read. Served by
 * cmd/building.
 *
 * BuildingService.ListNearbyBuildings ingests Mapbox POIs for any uncovered
 * S2 cell it is asked about (paid) and lazily seeds Rival Crews. That is
 * right for a phone standing in the street and wrong for a browser that can
 * pan the whole world, so this RPC only ever READS what already exists:
 * districts nobody has walked through come back empty, and the client says
 * "no intel yet". Per-viewer masking is identical to ListNearbyBuildings.
 *
 * @generated from service webgame.v1.WorldMapService
 */
export const WorldMapService: GenService<{
  /**
   * @generated from rpc webgame.v1.WorldMapService.ListBuildingsInBounds
   */
  listBuildingsInBounds: {
    methodKind: "unary";
    input: typeof ListBuildingsInBoundsRequestSchema;
    output: typeof ListBuildingsInBoundsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_webgame_v1_world_map, 0);

